import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LimitDialogComponent } from './components/limit-dialog/limit-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { LegacyDialogComponent } from './components/legacy-dialog/legacy-dialog.component';
import { FontAwesomeConfigModule } from '../font-awesome-config.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SaveBookmarkDialogComponent } from './components/save-bookmark-dialog/save-bookmark-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AccessDialogComponent } from './components/access-dialog/access-dialog.component';
import { GroupRestrictionDialogComponent } from './components/group-restriction-dialog/group-restriction-dialog.component';
import { ClipboardDialogComponent } from './components/clipboard-dialog/clipboard-dialog.component';
import { WelcomeTourDialogComponent } from './components/welcome-tour-dialog/welcome-tour-dialog.component';
import { DomainJoinDialogComponent } from './components/domain-join-dialog/domain-join-dialog.component';
import { AboutDialogComponent } from './components/about-dialog/about-dialog.component';
import { SaveModuleDialogComponent } from './components/save-module-dialog/save-module-dialog.component';
import { NpsDialogComponent } from './components/nps-dialog/nps-dialog.component';
import { ImportModelDialogComponent } from './components/import-model-dialog/import-model-dialog.component';
import { GalleryModule } from '../gallery/gallery.module';
import { AddTeamModelDialogComponent } from './components/add-team-model-dialog/add-team-model-dialog.component';
import { DialogState } from './state/dialog.state';
import { NgxsModule } from '@ngxs/store';
import { BackgroundColorDialogComponent } from './components/background-color-dialog/background-color-dialog.component';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    LimitDialogComponent,
    LegacyDialogComponent,
    SaveBookmarkDialogComponent,
    AccessDialogComponent,
    GroupRestrictionDialogComponent,
    ClipboardDialogComponent,
    WelcomeTourDialogComponent,
    DomainJoinDialogComponent,
    AboutDialogComponent,
    SaveModuleDialogComponent,
    NpsDialogComponent,
    ImportModelDialogComponent,
    AddTeamModelDialogComponent,
    BackgroundColorDialogComponent
  ],
  imports: [
    NgxsModule.forFeature([
      DialogState
    ]),
    CommonModule,
    FontAwesomeConfigModule,
    MaterialModule,
    SharedModule,
    ReactiveFormsModule,
    GalleryModule,
    ColorPickerModule
  ],
  exports: [
    ConfirmDialogComponent,
    LimitDialogComponent,
    LegacyDialogComponent,
    SaveBookmarkDialogComponent,
    AccessDialogComponent,
    GroupRestrictionDialogComponent,
    ClipboardDialogComponent,
    WelcomeTourDialogComponent,
    DomainJoinDialogComponent,
    AboutDialogComponent,
    SaveModuleDialogComponent,
    NpsDialogComponent,
    ImportModelDialogComponent,
    AddTeamModelDialogComponent,
    BackgroundColorDialogComponent
  ],
  entryComponents: [
    ConfirmDialogComponent,
    LimitDialogComponent,
    LegacyDialogComponent,
    SaveBookmarkDialogComponent,
    AccessDialogComponent,
    GroupRestrictionDialogComponent,
    ClipboardDialogComponent,
    WelcomeTourDialogComponent,
    DomainJoinDialogComponent,
    AboutDialogComponent,
    SaveModuleDialogComponent,
    NpsDialogComponent,
    ImportModelDialogComponent,
    AddTeamModelDialogComponent,
    BackgroundColorDialogComponent
  ]
})
export class DialogModule { }
